import React from "react";
import { _closeDrawer } from "router/helper";

import { TouchableOpacity } from "react-native";
import { Icon, Text } from "component";

import { mq } from "utils";
import { css } from "style";
import { colors, sizes } from "asset/constant";
import tinycolor from "tinycolor2";

type DrawerItemT = {
  title?: string;
  icon: IconT;
  onPress: () => void;
};

export default function Item(props: DrawerItemT) {
  const { title, icon, onPress } = props;

  return (
    <TouchableOpacity
      style={[
        { width: "90%" },
        css.height(40),
        css.paddingH,
        css.selfCenter,
        css.rRowCenterAlign,
      ]}
      activeOpacity={sizes.tapOpacity}
      onPress={() => {
        // _closeDrawer();
        setTimeout(onPress, 100);
      }}
    >
      <Icon
        {...icon}
        size={15}
        color={tinycolor(colors.theme).lighten(20).toString()}
      />
      <Text weight="bold" size={"sm"} style={{ bottom: mq(2) }}>
        {"  "}
        {title}{" "}
      </Text>
    </TouchableOpacity>
  );
}
